module.exports = __webpack_public_path__ + "static/media/Sibilia-hero.44c37335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/images/Sibilia-hero.png
// module id = 373
// module chunks = 0